



























import Vue from "vue";
import config from "@/configs";
import VueI18n from "vue-i18n";
import TranslateResult = VueI18n.TranslateResult;

interface LanguageOption {
  code: string;
  name: TranslateResult;
}

interface Data {
  showMenu: boolean;
  languages: LanguageOption[];
}

export default Vue.extend({
  name: "AppTranslationSelect",
  mounted() {
    config?.settings.languages.forEach((language) => {
      this.languages.push({
        code: language,
        name: this.$t(`language.${language.replace("-", "")}`),
      });
    });
  },
  data(): Data {
    return {
      showMenu: false,
      languages: [],
    };
  },
  methods: {
    onSelected(item: any) {
      localStorage.setItem("lang", item.code);
      this.$i18n.locale = item.code;
    },
  },
});
